import { storyblokEditable } from "gatsby-source-storyblok"

import EcoSystemListCard from "../../../../V2/Cards/EcoSystem/List"

import React from "react"

const StoryblokEcoSystemListCard = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.EcoSystemListCard>) => {
  return (
    <EcoSystemListCard
      backgroundColor={blok.backgroundColor}
      borderColor={blok.borderColor}
      titleText={blok.titleText}
      iconUrl={blok.icon?.filename}
      iconAlt={blok.icon?.alt}
      items={blok.items}
      size={blok.size}
      mobileGridOrder={mobileGridOrder}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokEcoSystemListCard
